









































import { Component, Vue } from 'vue-property-decorator'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import { normalize } from '@/utils/CommonUtils'
import { Company } from '@/utils/Interfaces'
import { handle } from '@/utils/ErrorHandling'

@Component({
  components: {
    BreadCrumbs,
    SectionTitle,
  }
})
export default class NhapLieu extends Vue {
  breadcrumbs = [
    {
      text: 'Trang chủ',
      to: { name: 'Home' },
    },
    {
      text: 'Nhập liệu',
      to: { name: 'NhapLieu' },
    },
  ]
  searchText = ''
  createDialog = false
  updateDialog = false

  company = new Company

  selectedCompany = {}

  mounted () {
    this.$store.dispatch('setCompanies').catch(handle)
  }

  get loading () {
    return this.$store.state.company.fetchingCompanies
  }

  get companies () {
    return this.$store.getters.getCompanies
  }

  get filteredCompanies (): Array<Company> {
    return this.companies.filter((company: Company) => {
      const searchText = normalize(this.searchText)
      const companyName = normalize(company.name)
      return companyName.includes(searchText)
    })
  }
}
